import { getBearerToken } from "../../../../api/postCall/bearerToken";
import { API_ENDPOINTS } from "../../../../enums/apiUrls";
import { OrganizationType } from "../../../../enums/organizationTypes";
import { buildPrimaryCareRowData } from "../utils/buildPrimaryCareRowData";

interface OnAsteraPrimaryCareSaveParams {
  data: any;
  outcome: string;
  routeVia: string;
  poc: string;
  key: string;
  comments?: string;
  onSuccess: () => void;
  onError: (error: Error) => void;
}

export const onAsteraPrimaryCareSave = async (
  params: OnAsteraPrimaryCareSaveParams,
) => {
  const { data, outcome, routeVia, poc, key, comments, onSuccess, onError } =
    params;

  try {
    const identifier = data?.identifier;
    if (!identifier) {
      throw new Error("Identifier not found in data");
    }

    const payload = {
      identifier,
      org_id: OrganizationType.ASTERA_PRIMARY_CARE,
      row_data: buildPrimaryCareRowData({
        key,
        outcome,
        routeVia,
        poc,
        comments,
      }),
    };

    const response = await fetch(API_ENDPOINTS.UPDATE_PRIMARY_CARE_ENTRY, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${await getBearerToken()}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.message || "Failed to update entry");
    }

    onSuccess();
  } catch (error) {
    console.error("Error in Astera Primary Care submission save");
    onError(error as Error);
  }
};
